import exposer from 'utils/exposer';
import { resetFormEffect } from 'common/compounds/FormRenderer/epics/form';

const hostApp = (store) => ({
    /**
     * Resets the kiosk mode form (after submission).
     * Clears previous answers and leaves the form ready for re-submitting.
     */
    resetForm: () => {
        // Forms v2
        window.splash && window.splash.PubSub && window.splash.PubSub.publish('rsvp-reset');
        // Forms v3
        store && store.dispatch && store.dispatch(resetFormEffect());
    },
});

/**
 * Expose a supported JavaScript lib for the hostApp to use to interact with the web view.
 */
export default (store) => exposer({ 'SPLASH.hostApp': hostApp(store) });
